/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Createdby1Inputs */

const en__field_createdby1 = /** @type {(inputs: _Field_Createdby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created by`)
};

/**
* | output |
* | --- |
* | "Created by" |
*
* @param {_Field_Createdby1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_createdby1 = /** @type {((inputs?: _Field_Createdby1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Createdby1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_createdby1(inputs)
});
export { _field_createdby1 as "_field_createdBy" }